import type React from 'react';
import { useTranslation } from 'react-i18next';
import { getSentimentLevel, SENTIMENT_DISPLAY } from '../sentimentDisplay';

type IntelligenceSentimentBarProps = {
  // 0..1 weighted satisfaction score; null when no classified conversations exist.
  score: number | null;
};

export const IntelligenceSentimentBar: React.FC<
  IntelligenceSentimentBarProps
> = ({ score }) => {
  const { t } = useTranslation();

  if (score === null) {
    return (
      <span className='intelligence__no-data'>{t('general.no-data')}</span>
    );
  }

  const percent = Math.round(score * 100);
  const display = SENTIMENT_DISPLAY[getSentimentLevel(score)];

  return (
    <div className='intelligence__bar-wrap'>
      <div className='intelligence__bar-track'>
        <div
          className={`intelligence__bar-fill ${display.barColorClass}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span
        className={`intelligence__bar-percent ${display.percentColorClass}`}>
        {percent}%
      </span>
    </div>
  );
};
